import styled from "styled-components";

const Textarea = styled.textarea`
  margin: 5px;
  padding: 12px;
  border: 1px solid transparent;
  border-radius: 4px;
  color: rgba(255, 255, 255, 0.75);
  background-color: rgba(255, 255, 255, 0.05);
  outline: 0;
  resize: vertical;
`;

export default Textarea;
